import { Fragment } from "react";
import { ThemeProvider } from "next-themes";
import Head from "next/head";

import "../styles/globals.css";
import "../styles/syntax.css";

import OgImage from "assets/og-image.png";

import SearchContainer from "components/search/SearchContainer";

import { fixTimeoutTransition } from "lib/fixTimeoutTransition";

import type { Page } from "../types/page";
import type { AppProps } from "next/app";

const META_TITLE = "Raycast - Supercharged productivity";
const META_DESCRIPTION =
  "Raycast lets you control your tools with a few keystrokes. It's designed to keep you focused.";
const META_IMAGE = `https://${process.env.NEXT_PUBLIC_VERCEL_URL}${OgImage.src}`;

type Props = AppProps & {
  Component: Page;
};

const TRANSITION_DURATION = 300;

fixTimeoutTransition(TRANSITION_DURATION);

function MyApp({ Component, pageProps }: Props) {
  const getLayout = Component.getLayout ?? ((page) => page);
  const Layout = Component.layout ?? Fragment;

  // TODO: remove `themes` and `defaultTheme` when light theme supported on more pages
  return (
    <Layout>
      <Head>
        <meta property="og:title" content={META_TITLE} />
        <meta property="og:description" content={META_DESCRIPTION} />
        <meta property="og:image" content={META_IMAGE} key="og-image" />
        <meta property="og:type" content="website" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:site" content="@raycastapp" />
        <meta name="description" content={META_DESCRIPTION} />
      </Head>
      <ThemeProvider themes={["dark"]} defaultTheme="dark">
        <SearchContainer />
        {getLayout(<Component {...pageProps} />)}
      </ThemeProvider>
    </Layout>
  );
}

export default MyApp;
